angular.module("ainapp")
    .controller("addTimesheetController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Time Sheet";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Time Sheet").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetTimeSheet(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.UpdateDetails = function (data) {

                $scope.addData = data;
                $scope.addData.Date = new Date($scope.addData.Date);

                angular.forEach(data.TimeSheetCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })



                angular.forEach($scope.addData.TimeSheetDetails, function (e) {

                    e.Date = new Date(e.Date);
                    e.EndDate = new Date(e.EndDate);

                    var costs = angular.copy($scope.CostCenters);
                    if (e.TimeSheetCosts.length > 0) {
                        angular.forEach(e.TimeSheetCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }


                    if (e.Date.getDay() == 0) {
                        e.IsSunday = true;
                    }
                    if (e.EndDate.getDay() == 0) {
                        e.IsEndSunday = true;
                    }



                });

                //                if (data.TimeSheetDetails.length <= 5) {
                //
                //                    var temp2 = 5 - data.TimeSheetDetails.length;
                //
                //                    for (var i = 0; i < temp2; i++) {
                //
                //                        $scope.InsertRow();
                //                    }
                //                }


            }



            $scope.InsertRows = function () {

                var now = new Date();
                var totDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();

                for (var i = 1; i <= totDays; i++) {

                    var date = $scope.addData.Year + "-" + $scope.addData.Month + "-" + i;

                    var timeSheetDetails = {
                        Date: new Date(date),
                        EndDate: new Date(date),
                        StartTime: "",
                        EndTime: "",
                        StartHour: 0,
                        StartMinute: 0,
                        EndHour: 0,
                        EndMinute: 0,

                        WorkHours: 0,
                        TotalHours: 0,
                        NormalHours: $scope.CompanyProfile.NormalOperationalHours,
                        BreakHours: 0,
                        OverTimeHours: 0,


                        Field1: "",
                        Field2: "",
                        Field3: "",
                        Field4: "",
                        Field5: "",
                        Field6: "",
                        Field7: "",
                        Field8: "",
                        Field9: "",
                        Field10: "",
                        CostCenters: angular.copy($scope.CostCenters),
                    }


                    if (timeSheetDetails.Date.getDay() == 0) {
                        timeSheetDetails.IsSunday = true;
                    }
                    if (timeSheetDetails.EndDate.getDay() == 0) {
                        timeSheetDetails.IsEndSunday = true;
                    }

                    $scope.addData.TimeSheetDetails.push(timeSheetDetails);

                }


            }

            $scope.InsertRow = function () {

                var len = $scope.addData.TimeSheetDetails.length;
                var last = $scope.addData.TimeSheetDetails[len - 1];

                var date = new Date(last.Date);
                date = date.setDate(date.getDate() + 1);

                var timeSheetDetails = {
                    Date: new Date(date),
                    EndDate: new Date(date),
                    StartTime: "",
                    EndTime: "",
                    StartHour: 0,
                    StartMinute: 0,
                    EndHour: 0,
                    EndMinute: 0,

                    WorkHours: 0,
                    TotalHours: 0,
                    NormalHours: $scope.CompanyProfile.NormalOperationalHours,
                    BreakHours: 0,
                    OverTimeHours: 0,


                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    CostCenters: angular.copy($scope.CostCenters),
                }


                $scope.addData.TimeSheetDetails.push(timeSheetDetails);
            }

            $scope.Init = function () {


                $scope.ViewVal = 0;
                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.addData = {
                    Date: new Date(),
                    Remarks: "",
                    VoucherNumber: "",

                    Month: $scope.monthsPlainArr[month],
                    Year: year,

                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",

                    TimeSheetDetails: [],
                    TimeSheetCosts: [],
                }




                $scope.ErrorText = "";
                $scope.Load = false;




                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Time Sheet").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;

                        $scope.InsertRows();


                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Time Sheet").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.addData.TimeSheetDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                        MainService.GetNextTimeSheetNo().then(function (response) {
                            $scope.addData.VoucherNumber = response.data;
                        });


                    })

                }


            }
            $scope.Init();

            $scope.rechaeckAll = function () {
                angular.forEach($scope.addData.TimeSheetDetails, function (e) {
                    $scope.click(e, 1);
                })
            }

            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                var dateObj = data.Date;
                var month = dateObj.getMonth() + 1;
                var day = dateObj.getDate();
                var year = dateObj.getFullYear();

                var dateObj2 = data.EndDate;
                var month2 = dateObj2.getMonth() + 1;
                var day2 = dateObj2.getDate();
                var year2 = dateObj2.getFullYear();

                if (data.StartHour != "" && data.StartMinute == "") {
                    data.StartMinute = "00";
                }

                if (data.EndHour != "" && data.EndMinute == "") {
                    data.EndMinute = "00";
                }

                if (data.StartHour != "" && data.StartMinute != "") {
                    var startTime = year + "-" + month + "-" + day + " " + data.StartHour + ":" + data.StartMinute;
                    $scope.SelectedCE.StartTime = new Date(startTime);
                }

                if (data.EndHour != "" && data.EndMinute != "") {
                    var EndTime = year2 + "-" + month2 + "-" + day2 + " " + data.EndHour + ":" + data.EndMinute;
                    $scope.SelectedCE.EndTime = new Date(EndTime);
                }

                $scope.SelectedCE.OverTimeHours = 0;
                if ($scope.SelectedCE.StartTime != null && $scope.SelectedCE.EndTime != null &&
                    $scope.SelectedCE.StartTime != "" && $scope.SelectedCE.EndTime != "") {
                    $scope.SelectedCE.WorkHours = Math.abs($scope.SelectedCE.StartTime - $scope.SelectedCE.EndTime) / 36e5;
                    $scope.SelectedCE.WorkHours = Math.round($scope.SelectedCE.WorkHours * 100) / 100;

                    $scope.SelectedCE.OverTimeHours = $scope.SelectedCE.WorkHours - $scope.SelectedCE.NormalHours;
                    $scope.SelectedCE.OverTimeHours = Math.round($scope.SelectedCE.OverTimeHours * 100) / 100;
                    if ($scope.SelectedCE.OverTimeHours < 0) {
                        $scope.SelectedCE.OverTimeHours = 0;
                    }

                    $scope.SelectedCE.TotalHours = $scope.SelectedCE.WorkHours - $scope.SelectedCE.BreakHours;
                }


                //                if ($scope.addData.TimeSheetDetails.length <= 5) {
                //
                //                    var temp2 = 5 - $scope.addData.TimeSheetDetails.length;
                //
                //                    for (var i = 0; i < temp2; i++) {
                //
                //                        $scope.InsertRow();
                //                    }
                //                }

            }

            $scope.updateDate = function () {
                angular.forEach($scope.addData.TimeSheetDetails, function (e) {

                    var day = e.Date.getDate();
                    var date = $scope.addData.Year + "-" + $scope.addData.Month + "-" + day;
                    e.Date = new Date(date);
                    e.EndDate = new Date(date);

                    if (e.Date.getDay() == 0) {
                        e.IsSunday = true;
                    } else {
                        e.IsSunday = false;
                    }
                    if (e.EndDate.getDay() == 0) {
                        e.IsEndSunday = true;
                    } else {
                        e.IsEndSunday = false;
                    }

                    $scope.click(e);
                })
            }


            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ErrorText = "";

                angular.forEach($scope.addData.TimeSheetDetails, function (e) {

                    e.TimeSheetCosts = [];
                    angular.forEach(e.CostCenters, function (a) {
                        if (a.Section == "Body") {
                            if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                            } else {
                                if (a.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: a.SelectedCostCenterId,
                                    }
                                    e.TimeSheetCosts.push(cst);
                                    console.log(e);
                                }
                            }
                        }
                    })

                    e.CostCenters = [];

                })

                $scope.addData.TimeSheetCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.addData.TimeSheetCosts.push(cst);
                            }
                        }
                    }
                })


                if ($scope.ErrorText == "") {
                    $('#saveModal').modal('show');
                } else {
                    toastr.warning($scope.ErrorText);
                }


            }

            $scope.SaveWithConfirm = function () {

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.addData.DateString = $scope.extractDate($scope.addData.Date);

                angular.forEach($scope.addData.TimeSheetDetails, function (e) {
                    e.DateString = $scope.extractDate(e.Date);
                    e.EndDateString = $scope.extractDate(e.EndDate);
                })

                MainService.addTimeSheet($scope.addData).then(function (response) {
                    if (response.data) {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Time Sheet', $scope.addData.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $('#mymodal2').modal('hide');
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("timeSheets");
                } else {
                    $scope.Init();
                }

            }


            var loadViewDatas = function (_selectedReceipt) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCPV(_selectedReceipt.Id).then(function (response) {

                    $scope.CurrentCPV = response.data[0];

                    $scope.AccountNumber = $scope.CurrentCPV.VoucherNumber;
                    $scope.CurrentCPV.Date = new Date($scope.CurrentCPV.Date);
                    $scope.CurrentCPV.AccountName = $scope.CurrentCPV.Account.Name;

                    angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {
                        if (e.BuildingId > 0) {
                            $scope.getFlats(e);
                        }
                        if (e.VehicleCategoryId > 0) {
                            $scope.getVehicles(e);
                        }

                    })


                    if ($scope.CurrentCPV.CPVDetails.length <= 5) {

                        var temp2 = 5 - $scope.CurrentCPV.CPVDetails.length;

                        if (temp2 > 0) {
                            for (var i = 0; i < temp2; i++) {

                                var CPVDetails = {
                                    Id: "",
                                    AccountId: "",
                                    Amount: 0,
                                    Description: "",
                                    Account: {},
                                    Flats: [],
                                }

                                $scope.CurrentCPV.CPVDetails.push(CPVDetails);
                            }
                        }

                    }


                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            };

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    if ($scope.addData.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }


            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteTimeSheet($scope.addData.Id).then(function (response) {
                        if (response.data) {
                            toastr.success("Deleted");
                            $('#deleteModal').modal('hide');
                            $state.go("timeSheets");
                        } else {
                            toastr.warning("Failed");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                    })
            }


            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.deleteRow = function () {
                var index = $scope.addData.TimeSheetDetails.indexOf($scope.ClickedRow);
                $scope.addData.TimeSheetDetails.splice(index, 1);
            }

            $scope.GetBackVoucher = function (type) {
                var temp = 0;
                if ($scope.addData.Id > 0) {
                    temp = $scope.addData.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackTimeSheet(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentCPV.CPVDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });



                }])
